import { StyleSheet } from 'aphrodite';
import { addAlphaToHex } from '../../../../../../models/UiUtils';
import { THEME } from '../../../../../../web/components-v2/Theme/theme';
import { brandPrimary, destructive, successGreen, titles } from '../../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../../web/styles/styles';

const { colors, spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	section: {
		borderRadius: 3,
		boxSizing: 'border-box',
		padding: `${spacing.md}px ${spacing.md}px 0`,
		width: 452,
	},
	sectionNoBorderTop: {
		borderTop: spacing.none,
	},
	borderRightBottom: {
		borderRight: common.border,
		borderBottom: common.border,
		borderTopRightRadius: 0,
		borderBottomRightRadius: common.borderRadius,
	},
	sectionTitle: {
		color: titles,
	},
	bottomSection: {
		background: colors.background.light,
		width: '100%',
		boxSizing: 'border-box',
		position: 'relative',
		marginBottom: spacing.md,
		borderTopLeftRadius: common.borderRadius,
		borderBottomLeftRadius: common.borderRadius,

		...CssSelectors.allChildren(
			{
				padding: `${spacing.md}px ${spacing.md}px 0`,
				...CssSelectors.allChildren(
					{
						margin: `0 0 ${spacing.md}px 0`,
					},
					'h3'
				),
			},
			'header'
		),
	},
	sectionFullWidth: {
		width: '100%',
		boxSizing: 'border-box',
		marginBottom: spacing.lg,
	},
	addQuestionButton: {
		padding: spacing.md,
		width: '100%',
		textAlign: 'center',
		color: brandPrimary,
		background: addAlphaToHex(brandPrimary, 0.1, '#FFFFFF'),
		border: `2px dashed ${brandPrimary}`,
		borderRadius: common.borderRadius,
	},
	tagPrefixContainer: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
		justifyContent: 'flex-end',
		borderRight: common.border,
		paddingRight: spacing.sm,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		...CssSelectors.allDescendants(
			{
				margin: 0,
				fontSize: THEME.typography.fontSizes.xs,
			},
			'p'
		),
	},
	removeQuestionButton: {
		transform: 'translateY(-60px)',
	},
	bottomSectionNotSaved: {
		borderLeft: `4px solid ${brandPrimary}`,
	},
	bottomSectionSaved: {
		borderLeft: `4px solid ${successGreen}`,
	},
	bottomSectionNoValue: {
		borderLeft: `4px solid ${destructive}`,
	},
	afterInputIcon: {
		top: 12,
		right: 8,
		...CssSelectors.allDescendants(
			{
				fill: THEME.colors.pill.blue.icon,
				cursor: 'pointer',
			},
			'svg path'
		),
	},
	removeOptionButton: {
		background: 'transparent',
		border: 'none',
		padding: '0 !important',
		margin: 0,
		cursor: 'pointer',
		color: THEME.colors.text.light,
		width: 16,
		height: 16,
		boxShadow: 'none',
		':hover': {
			background: 'transparent',
			border: 'none',
			padding: '0 !important',
			margin: 0,
			cursor: 'pointer',
		},
	},
});
